import type { FC, RefObject } from 'react';
import { useCallback, useRef } from 'react';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';

import { TimerLevel } from 'store/conference/events/attachTimerMessageReceivedEvent';
import { useCurrentUserStore } from 'store/currentUser';
import { useTimerStore } from 'store/timer';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import styles from './styles.module.scss';
import Time from './Time';
import TimerPopup from './TimerPopup';
import TimerPopupContextProvider, { useTimerPopupContext } from './TimerPopup/Context';

const TimerButton: FC = () => {
    const buttonRef = useRef<HTMLElement>(null);
    const { isDesktop } = useDeviceWidth();
    const { setAnchor } = useTimerPopupContext();
    const { availableTime, setNotification, timerConfig } = useTimerStore();
    const { currentUser } = useCurrentUserStore();
    const { triggerYM } = useYM();

    const handleClick = useCallback(() => {
        const isManager = currentUser?.type === 'manager';
        const isAllowedByTime = (timerConfig?.[TimerLevel.TWO] ?? 0) > (availableTime ?? 0);

        if (isAllowedByTime && isManager) {
            triggerYM({ goal: GoalType.CONFERENCE_PAGE_TIMER });
            setAnchor(buttonRef as RefObject<HTMLElement>);
            setNotification(availableTime);
        }
    }, [timerConfig, availableTime, currentUser?.type]);

    return (
        <Button
            kind='gray'
            ref={buttonRef}
            className={styles.wrapper}
            size={isDesktop ? 'lg' : 'md'}
            borderRadius='full'
            onClick={handleClick}
            insideIndent={3}
        >
            <Time />
        </Button>
    );
};

const Timer: FC = () => {
    return (
        <TimerPopupContextProvider>
            <TimerButton />
            <TimerPopup />
        </TimerPopupContextProvider>
    );
};

export default Timer;
